import { ShowSnackbar } from '../../shared/shared.actions'
import {
  FetchMobileUsersSuccess,
  FetchMobileUsersFailure,
  FetchMobileUsersRequest,
  DeleteMobileUserRequest,
  DeleteMobileUserSuccess,
  DeleteMobileUserFailure,
  CreateMobileUserRequest,
  CreateMobileUserSuccess,
  CreateMobileUserFailure,
  FetchMobileUserSuccess,
  FetchMobileUserFailure,
  FetchMobileUserRequest,
  UpdateMobileUserRequest,
  UpdateMobileUserSuccess,
  UpdateMobileUserFailure,
  ReissueActivationCodeRequest,
  ReissueActivationCodeSuccess,
  ReissueActivationCodeFailure,
} from './mobile-users.actions'
import { Injectable } from '@angular/core'
import { Observable, of } from 'rxjs'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import * as UsersTypes from './mobile-users.types'

import { map, switchMap, tap, catchError } from 'rxjs/operators'
import { Router } from '@angular/router'
import { MobileUsersService } from './mobile-users.service'

@Injectable()
export class MobileUsersEffects {
  constructor(
    private actions: Actions,
    private usersService: MobileUsersService,
    private router: Router,
  ) {}

  FetchMobileUsers$ = createEffect(() =>
    this.actions.pipe(
      ofType(UsersTypes.FETCH_MOBILE_USERS_REQUEST),
      switchMap((action: FetchMobileUsersRequest) => {
        return this.usersService.fetchMobileUsers(action.payload).pipe(
          map((result) => {
            return new FetchMobileUsersSuccess(
              result.data.results,
              result.data.totalCount,
              result.data.filteredCount,
            )
          }),
          catchError((err, caught) => {
            console.log(err)
            return of(new FetchMobileUsersFailure({ error: err }))
          }),
        )
      }),
    ),
  )

  FetchMobileUser$ = createEffect(() =>
    this.actions.pipe(
      ofType(UsersTypes.FETCH_MOBILE_USER_REQUEST),
      switchMap((action: FetchMobileUserRequest) => {
        return this.usersService.fetchMobileUser(action.id).pipe(
          map((result) => {
            return new FetchMobileUserSuccess(result.data, action.property)
          }),
          catchError((err, caught) => {
            return of(
              new FetchMobileUserFailure({ error: err }, action.property),
            )
          }),
        )
      }),
    ),
  )

  DeleteMobileUser$ = createEffect(() =>
    this.actions.pipe(
      ofType(UsersTypes.DELETE_MOBILE_USER_REQUEST),
      switchMap((action: DeleteMobileUserRequest) => {
        return this.usersService.deleteMobileUser(action.id).pipe(
          switchMap((result) => {
            return [new DeleteMobileUserSuccess()]
          }),
          catchError((err, caught) => {
            return of(new DeleteMobileUserFailure({ error: err }))
          }),
        )
      }),
    ),
  )

  CreateMobileUser$ = createEffect(() =>
    this.actions.pipe(
      ofType(UsersTypes.CREATE_MOBILE_USER_REQUEST),
      switchMap((action: CreateMobileUserRequest) => {
        return this.usersService.createMobileUser(action.payload).pipe(
          switchMap((result) => {
            this.router.navigate(['/admin/mobile-users'])
            return [new CreateMobileUserSuccess()]
          }),
          catchError((err, caught) => {
            return of(new CreateMobileUserFailure({ error: err }))
          }),
        )
      }),
    ),
  )

  UpdateMobileUser$ = createEffect(() =>
    this.actions.pipe(
      ofType(UsersTypes.UPDATE_MOBILE_USER_REQUEST),
      switchMap((action: UpdateMobileUserRequest) => {
        return this.usersService
          .updateMobileUser(action.id, action.payload)
          .pipe(
            switchMap((result) => {
              // this.router.navigate(['/admin/mobile-users'])
              return [
                new FetchMobileUserRequest(action.id, 'updateUser'),
                new UpdateMobileUserSuccess(),
              ]
            }),
            catchError((err, caught) => {
              return of(new UpdateMobileUserFailure({ error: err }))
            }),
          )
      }),
    ),
  )

  ReissueActivationCode$ = createEffect(() =>
    this.actions.pipe(
      ofType(UsersTypes.REISSUE_ACTIVATION_CODE_REQUEST),
      switchMap((action: ReissueActivationCodeRequest) => {
        return this.usersService.reissueActivationCode(action.userId).pipe(
          switchMap((result) => {
            return [
              new FetchMobileUserRequest(action.userId, 'updateUser'),
              new ReissueActivationCodeSuccess(result.data),
            ]
          }),
          catchError((err, caught) => {
            return of(new ReissueActivationCodeFailure({ error: err }))
          }),
        )
      }),
    ),
  )
}
